import { render, staticRenderFns } from "./groupItem.vue?vue&type=template&id=906c4f96&"
import script from "./groupItem.vue?vue&type=script&lang=js&"
export * from "./groupItem.vue?vue&type=script&lang=js&"
import style0 from "./groupItem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports